// extracted by mini-css-extract-plugin
module.exports = {"heading":"LegalInformationPage_heading__2HZ6s","content":"LegalInformationPage_content__KMWSG","text":"LegalInformationPage_text__2-bEP"};